var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-skeleton-loader',{staticClass:"rounded-xl custom-elevation booking-location-list-item__skeleton",attrs:{"loading":"","type":"image"}})}
var staticRenderFns = []

export { render, staticRenderFns }